import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { selectProgramContentLibraryMeta } from './selectors';
import { updateProgramContentFilters } from './actions';
import { loadDashboardFilters } from 'actions/partner';

import EditSearch from 'components/filters/EditSearch';


class ProgramContentLibraryFilters extends React.Component {
  constructor(props) {
    super(props);

    this.handleTitleSearchQueryChange = this.handleTitleSearchQueryChange.bind(this);
  }

  componentDidMount() {
    this.props.loadDashboardFilters();
  }

  render() {
    return (
      <div className='row u-margin-top--base u-margin-bottom--large'>
        <div className='column small-12 medium-4 large-3'>
          { this.renderTitleSearch() }
        </div>
      </div>
    );
  }

  renderTitleSearch() {
    const { q } = this.props.meta;

    return (
      <EditSearch
        placeholder='Search by entry by title...'
        value={q}
        onChange={this.handleTitleSearchQueryChange}
        disabled={this.props.isLoading}
      />
    );
  }

  handleTitleSearchQueryChange(query) {
    this.props.updateProgramContentFilters({
      q: query,
    });
  }

}


const mapStateToProps = (state) => {
  return {
    meta: selectProgramContentLibraryMeta(state),
  };
};

const mapDispatchToProps = {
  loadDashboardFilters,
  updateProgramContentFilters,
};

ProgramContentLibraryFilters.propTypes = {
  meta: PropTypes.object.isRequired,
  loadDashboardFilters: PropTypes.func.isRequired,
  updateProgramContentFilters: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProgramContentLibraryFilters);
